'use es6';

import PropTypes from 'prop-types';
import UIImage from 'UIComponents/image/UIImage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { jsx as _jsx } from "react/jsx-runtime";
const IconListItem = ({
  iconUrl,
  title
}) => {
  return /*#__PURE__*/_jsx(UIMediaObject, {
    className: "m-bottom-2",
    align: "start",
    itemLeft: /*#__PURE__*/_jsx(UIImage, {
      height: "20px",
      width: "20px",
      src: iconUrl
    }),
    children: title
  });
};
IconListItem.propTypes = {
  iconUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default IconListItem;